module.exports = "<template>\n  <div id=\"map\" class=\"mapswrap\"></div>  \n</template>";